import '../scss/main.scss';

import { followMenu } from './components/followMenu';
import { hamburger } from './components/hamburger';
import { langSwitcher } from './components/langSwitcher';
import { mobileSearchForm } from './components/mobileSearchForm';
import { desktopSearchForm } from './components/desktopSearchForm';
import { scrollToTop } from './components/scrollToTop';
import { sliders } from './components/sliders';
import { stepsAccordion } from './components/stepsAccordion';
import { formFocus } from './components/formFocus';
import { filterPosts } from './components/filters/filterPosts';
import { counter } from './components/counter';
import { playVideo } from './components/playVideo';
import { formRegranulat } from './components/formRegranulat';
import { regranulatyStepsAccordion } from './components/regranulatyStepsAccordion';
import { changeSpanToImage } from './components/changeSpanToImage';
import { filterRegranulaty } from './components/filters/filterRegranulaty';
import { sortRegranulaty } from './components/filters/sortRegranulaty';
import { toggleFilters } from './components/filters/toggleFilters';
import { comparePopup } from './components/compare/comparePopup';
import { initCompare } from './components/compare';
import { initProductsBreaker } from './components/compare/productsBreaker';
import { initQuery } from './components/query';
import { smoothScroll } from './components/smoothScroll';
import { technologyNav } from './components/technologyNav';

/* Defining Site URL for images, so the website works on subfolder wordpress instances as well as global/absolute instances */
if (typeof themeSettings !== 'undefined') {
  __webpack_public_path__ = `${themeSettings.baseUrl}/wp-content/themes/sirema/dist/images/`;
}

document.addEventListener('DOMContentLoaded', async () => {
  smoothScroll();
  langSwitcher();
  mobileSearchForm();
  hamburger();
  followMenu();
  desktopSearchForm();
  scrollToTop();
  sliders();
  stepsAccordion();
  formFocus();
  filterPosts();
  counter();
  playVideo();
  formRegranulat();
  regranulatyStepsAccordion();
  changeSpanToImage();
  filterRegranulaty();
  sortRegranulaty();
  toggleFilters();
  initQuery();
  comparePopup();
  initProductsBreaker();
  technologyNav();
  await initCompare();
});